import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const Verified = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.33 3.032a.82.82 0 0 0-.453 0L4.583 5.134A.801.801 0 0 0 4 5.902v4.31c0 4.876 3.16 9.206 7.845 10.747a.82.82 0 0 0 .512 0c4.684-1.541 7.843-5.87 7.843-10.746v-4.31a.801.801 0 0 0-.583-.769l-7.286-2.102Zm4.906 6.904a.9.9 0 1 0-1.272-1.272L11.2 13.427l-2.064-2.063a.9.9 0 1 0-1.272 1.272l3.336 3.337 6.036-6.037Z"
    />
  </Icon>
);

export default Verified;
